import { render, staticRenderFns } from "./DataExchangeLog.vue?vue&type=template&id=14638704"
import script from "./DataExchangeLog.vue?vue&type=script&lang=js"
export * from "./DataExchangeLog.vue?vue&type=script&lang=js"
import style0 from "./DataExchangeLog.vue?vue&type=style&index=0&id=14638704&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports